import { Center } from "@chakra-ui/react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../context/AuthContext";

const Home = () => {
  return (
    <>
      <Center>Home page</Center>
    </>
  );
};

export default Home;
